const DIGIT_WORDS = Object.freeze([
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "niner",
] as const);

const SMALL_NUMBERS = Object.freeze([
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
  "eleven",
  "twelve",
  "thirteen",
  "fourteen",
  "fifteen",
  "sixteen",
  "seventeen",
  "eighteen",
  "nineteen",
] as const);

const TENS = Object.freeze([
  "",
  "",
  "twenty",
  "thirty",
  "forty",
  "fifty",
  "sixty",
  "seventy",
  "eighty",
  "ninety",
] as const);

export function digitsToWords(digits: string): string {
  return (digits.match(/./gu) ?? [])
    .map((digit) => DIGIT_WORDS[Number(digit)] ?? digit)
    .join(" ");
}

function requiredWord(values: readonly string[], index: number): string {
  const word = values[index];
  /* v8 ignore next 2 -- callers range-check every array index */
  if (word === undefined)
    throw new RangeError("number-word index out of range");
  return word;
}

export function numberToWords(value: number): string {
  if (!Number.isInteger(value) || value < 0 || value > 9999) {
    throw new RangeError("value must be an integer from 0 to 9999");
  }
  if (value < 20) return requiredWord(SMALL_NUMBERS, value);
  if (value < 100) {
    const remainder = value % 10;
    const tens = requiredWord(TENS, Math.floor(value / 10));
    return remainder === 0
      ? tens
      : `${tens} ${requiredWord(SMALL_NUMBERS, remainder)}`;
  }
  if (value < 1000) {
    const remainder = value % 100;
    const hundreds = `${requiredWord(SMALL_NUMBERS, Math.floor(value / 100))} hundred`;
    return remainder === 0
      ? hundreds
      : `${hundreds} ${numberToWords(remainder)}`;
  }
  const remainder = value % 1000;
  const thousands = `${numberToWords(Math.floor(value / 1000))} thousand`;
  return remainder === 0
    ? thousands
    : `${thousands} ${numberToWords(remainder)}`;
}

export function spellLetters(value: string): string {
  return (value.replaceAll("-", "").match(/./gu) ?? []).join(" ");
}
